/** Pages that would only bounce a signed-in user back to where they just came from. */
const AUTH_PAGES = ["/", "/signin", "/register", "/register/create-account", "/onboarding", "/creating-profile"];
const PROFILE = "/profile";

function isAndroidPhone() {
	return window.navigator.userAgent.match(/Android/i) !== null;
}

/**
 * Where a user who just signed in should land: an explicit `?ref=`, else the page that sent them to
 * the form, else their profile.
 */
export function resolveSignedInDestination(): string {
	const ref = new URLSearchParams(window.location.search).get("ref");
	if (ref) return ref;

	const referrer = document.referrer ? new URL(document.referrer) : null;
	// Off-site referrers say nothing about where to go on our side — arriving from a Google search
	// would otherwise send the user to /search.
	if (!referrer || referrer.origin !== window.location.origin || AUTH_PAGES.includes(referrer.pathname)) {
		return PROFILE;
	}

	return `${referrer.pathname}${referrer.search}`;
}

/**
 * Leave the auth form for an existing account. Callers that have synchronously updated their auth
 * state may provide an SPA redirect; older sign-in paths keep the full load that reboots the app
 * from the persisted token.
 */
export function redirectAfterSignIn(token: string, redirectOnWeb?: (destination: string) => void) {
	if (isAndroidPhone()) {
		try {
			// The Android app opens the web sign-in and takes the token back through this scheme.
			window.location.href = `dproz://redirect?token=${encodeURIComponent(token)}`;
			return;
		} catch {
			// No handler registered for the scheme — fall through to the web destination.
		}
	}

	const destination = resolveSignedInDestination();
	if (redirectOnWeb) {
		redirectOnWeb(destination);
		return;
	}

	window.location.href = destination;
}
